import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { isString } from "../app/utils";
import { setUser } from "../app/userSlice";
import { siteApiSlice } from "../app/siteApiSlice";
import Footer from "../features/footer/Footer";
import Header from "../features/header/Header";
import { useGetSelfMutation } from "../features/users/usersApiSlice";
import { applyAccessibility } from "../features/accessibility/accessibilityUtil";

export default function Private(props: any) {
	const {
		isLoggedIn,
		userId: loggedInUserId,
		isTeachersWriterAccount,
		requiresAccountConfirmation,
		bypassTermsOfService,
	} = useAppSelector((state) => state.user);
	const [userId] = useState(loggedInUserId);

	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const location = useLocation();

	const [callGetSelf] = useGetSelfMutation();

	useEffect(() => {
		callGetSelf()
			.unwrap()
			.then((payload) => {
				dispatch(setUser({ ...payload }));
				applyAccessibility(payload.accessibility);
			})
			.catch((error: any) => {
				const e = isString(error) ? error : JSON.stringify(error);
				console.log(`error calling GetSelf, error = ${e}`);
			});
	}, []);

	useEffect(() => {
		if (!isLoggedIn || !loggedInUserId || loggedInUserId !== userId) {
			dispatch(siteApiSlice.util.resetApiState());
			if (!isTeachersWriterAccount || !isLoggedIn) navigate("/login");
		}
	}, [isLoggedIn, loggedInUserId]);

	useEffect(() => {
		if (!bypassTermsOfService) {
			navigate("/termsOfService");
		} else if (requiresAccountConfirmation) {
			navigate("/myAccount");
		}
	}, [location.pathname]);

	return (
		<div className="flex flex-col min-h-screen bg-white">
			<Header />
			<main className="mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8 py-8 w-screen">
				<Outlet />
			</main>
			<Footer />
		</div>
	);
}
